<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body border-top" v-for="(warehouse, index) in warehouses" v-bind:key="index">
                        <div class="row m-b-0">
                            <div class="col-lg-4 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span>Name</span>
                                        <h3 class="font-medium m-b-0">{{warehouse.name}}</h3>
                                        <p class="text-muted">{{warehouse.description}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span>Address</span>
                                        <address>
                                            {{warehouse.address.line1}}
                                            <br v-if="!isNullOrEmpty(warehouse.address.line2)"> {{warehouse.address.line2}}
                                            <br> {{warehouse.address.city}} {{warehouse.address.postal_code}}
                                            <br> {{warehouse.address.country}}
                                        </address>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div class="user-image">
                                        <img class="img-thumbnail"
                                             v-bind:src="warehouse.src"
                                             v-if="warehouse.attachments && warehouse.attachments.length>0"
                                             :width="100"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :page-count=pageCount
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="pageHandler"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :next-class="'page-link'"
                        :container-class="'pagination float-right'"
                        :page-class="'page-link'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Warehouses",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate},
        data() {
            return {
                warehouses: [],
                pageCount: 1,
                total: 0
            };
        },
        mounted() {
            console.log(this.currentOrg);
            this.getWareHouses(1);
        },
        methods: {
            async getWareHouses(page) {
                $(".preloader").fadeIn();
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                    params: {
                        page: page,
                        perPage: 10
                    }
                });

                $(".preloader").fadeOut();
                this.total = reply.data.total;
                this.setPageCount();
                this.warehouses = reply.data.warehouses;
                await this.getSignedUrls();
            },
            async getSignedUrls() {
                for(const warehouse of this.warehouses) {
                    if(warehouse.attachments && warehouse.attachments.length > 0) {
                        let filepath     = warehouse.attachments[0].filepath;
                        let result       = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${warehouse.id}/signedUrl`, {
                            params: {
                                type: 'read',
                                key: filepath
                            }
                        });
                        warehouse['src'] = result.data.url;
                    }
                }
                this.warehouses = JSON.parse(JSON.stringify(this.warehouses));
            },
            pageHandler(pageNum) {
                this.getWareHouses(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            isNullOrEmpty(str) {
                if(str !== null && str !== undefined && (str).trim() !== '') {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
</script>

<style scoped>

</style>
